import React, { useState } from "react";
import { useAuthStore } from "../stores/authStore";
import {
  IconUser,
  IconMail,
  IconPhone,
  IconCar,
  IconSettings,
  IconLogout,
  IconEdit,
  IconCamera,
} from "@tabler/icons-react";

const Profile = () => {
  const user = useAuthStore((state: any) => state.user);
  const logout = useAuthStore((state: any) => state.logout);
  const [isEditing, setIsEditing] = useState(false);

  const handleLogout = () => {
    logout();
    window.location.href = "/login";
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-green-50 via-white to-blue-50 pb-20">
      {/* Header del perfil */}
      <div className="bg-white shadow-sm border-b border-gray-200 px-6 py-8">
        <div className="flex items-center justify-between mb-6">
          <h1 className="text-2xl font-bold text-gray-900">Mi Perfil</h1>
          <button
            onClick={() => setIsEditing(!isEditing)}
            className="flex items-center space-x-2 px-4 py-2 bg-green-100 text-green-700 rounded-xl hover:bg-green-200 transition-colors duration-200"
          >
            <IconEdit size={18} />
            <span className="text-sm font-medium">
              {isEditing ? "Cancelar" : "Editar"}
            </span>
          </button>
        </div>

        {/* Foto de perfil */}
        <div className="flex flex-col items-center mb-6">
          <div className="relative">
            <img
              src="https://cdn-icons-png.flaticon.com/512/4697/4697360.png"
              alt="Profile"
              className="w-24 h-24 rounded-full border-4 border-white shadow-lg"
            />
            {isEditing && (
              <button className="absolute -bottom-2 -right-2 w-8 h-8 bg-green-500 text-white rounded-full flex items-center justify-center shadow-lg hover:bg-green-600 transition-colors duration-200">
                <IconCamera size={16} />
              </button>
            )}
          </div>
          <h2 className="text-xl font-bold text-gray-900 mt-4">
            {user.username}
          </h2>
          <p className="text-sm text-gray-600">Conductor Binntu</p>
        </div>
      </div>

      {/* Información del perfil */}
      <div className="px-6 py-8 space-y-6">
        {/* Información personal */}
        <div className="bg-white rounded-2xl shadow-lg p-6 border border-gray-100">
          <h3 className="text-lg font-semibold text-gray-900 mb-4 flex items-center">
            <IconUser size={20} className="text-green-600 mr-2" />
            Información Personal
          </h3>

          <div className="space-y-4">
            <div className="flex items-center space-x-3">
              <div className="w-10 h-10 bg-green-100 rounded-full flex items-center justify-center">
                <IconMail size={20} className="text-green-600" />
              </div>
              <div className="flex-1">
                <p className="text-sm font-medium text-gray-900">
                  Correo electrónico
                </p>
                <p className="text-sm text-gray-600">{user.email}</p>
              </div>
            </div>

            <div className="flex items-center space-x-3">
              <div className="w-10 h-10 bg-blue-100 rounded-full flex items-center justify-center">
                <IconPhone size={20} className="text-blue-600" />
              </div>
              <div className="flex-1">
                <p className="text-sm font-medium text-gray-900">Teléfono</p>
                <p className="text-sm text-gray-600">+57 300 123 4567</p>
              </div>
            </div>
          </div>
        </div>

        {/* Información del vehículo */}
        <div className="bg-white rounded-2xl shadow-lg p-6 border border-gray-100">
          <h3 className="text-lg font-semibold text-gray-900 mb-4 flex items-center">
            <IconCar size={20} className="text-green-600 mr-2" />
            Información del Vehículo
          </h3>

          <div className="space-y-4">
            <div className="flex items-center space-x-3">
              <div className="w-10 h-10 bg-purple-100 rounded-full flex items-center justify-center">
                <IconCar size={20} className="text-purple-600" />
              </div>
              <div className="flex-1">
                <p className="text-sm font-medium text-gray-900">
                  ID del Transporte
                </p>
                <p className="text-sm text-gray-600">{user.transportId}</p>
              </div>
            </div>

            <div className="flex items-center space-x-3">
              <div className="w-10 h-10 bg-orange-100 rounded-full flex items-center justify-center">
                <IconSettings size={20} className="text-orange-600" />
              </div>
              <div className="flex-1">
                <p className="text-sm font-medium text-gray-900">Estado</p>
                <p className="text-sm text-gray-600">
                  {user.isAvailable ? "Disponible" : "No disponible"}
                </p>
              </div>
            </div>
          </div>
        </div>

        {/* Estadísticas */}
        <div className="bg-white rounded-2xl shadow-lg p-6 border border-gray-100">
          <h3 className="text-lg font-semibold text-gray-900 mb-4">
            Estadísticas
          </h3>

          <div className="grid grid-cols-2 gap-4">
            <div className="text-center p-4 bg-green-50 rounded-xl">
              <p className="text-2xl font-bold text-green-600">127</p>
              <p className="text-sm text-gray-600">Viajes completados</p>
            </div>
            <div className="text-center p-4 bg-blue-50 rounded-xl">
              <p className="text-2xl font-bold text-blue-600">4.8</p>
              <p className="text-sm text-gray-600">Calificación</p>
            </div>
            <div className="text-center p-4 bg-purple-50 rounded-xl">
              <p className="text-2xl font-bold text-purple-600">89</p>
              <p className="text-sm text-gray-600">Horas en línea</p>
            </div>
            <div className="text-center p-4 bg-orange-50 rounded-xl">
              <p className="text-2xl font-bold text-orange-600">$2.4M</p>
              <p className="text-sm text-gray-600">Ganancias</p>
            </div>
          </div>
        </div>

        {/* Botón de cerrar sesión */}
        <div className="bg-white rounded-2xl shadow-lg p-6 border border-gray-100">
          <button
            onClick={handleLogout}
            className="w-full flex items-center justify-center space-x-2 px-4 py-3 bg-red-50 text-red-600 rounded-xl hover:bg-red-100 transition-colors duration-200"
          >
            <IconLogout size={20} />
            <span className="font-medium">Cerrar Sesión</span>
          </button>
        </div>
      </div>

      {/* Espacio para el footer */}
      <div className="h-20"></div>
    </div>
  );
};

export default Profile;
